import { FormattedMessage } from 'react-intl'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  const { variation } = useExperiment(Experiments.croOfferCtaSeeDeal)
  if (textOnly) {
    if (variation === 'variant') {
      return <FormattedMessage
        id="NiSGACYS_pNN1JTbfHZ7"
        defaultMessage="See deal"
        description="CTA text-only button label for the experiment variant on offer card listings"
      />
    } else {
      return <FormattedMessage
        id="fmQoCma2QV_Cs2oKJd4k"
        defaultMessage="View offer"
        description="CTA text-only button label for viewing the full offer details on offer card listings"
      />
    }
  } else {
    if (variant === 'default' && variation === 'variant') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          <FormattedMessage
            id="A3F-cqNljaxszNPrl8Ff"
            defaultMessage="See deal"
            description="CTA button label for the experiment variant on desktop default offer cards"
          />
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'default') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          <FormattedMessage
            id="QRWBrCWyrfw5EkB88Ukz"
            defaultMessage="View"
            description="Short CTA button label for viewing an offer on desktop in the default card variant"
          />
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'condensed' && variation === 'variant') {
      return <TextButton kind="secondary" nonInteractable>
        <CSSBreakpoint as="span" max="tablet">
          <FormattedMessage
            id="LH-7bbY00emRvF1RIUja"
            defaultMessage="See"
            description="First word of 'See deal' button text. The word 'deal' follows on desktop only."
          />
        </CSSBreakpoint>
        <CSSBreakpoint as="span" min="desktop">
          <FormattedMessage
            id="NiSGACYS_pNN1JTbfHZ7"
            defaultMessage="See deal"
            description="CTA text-only button label for the experiment variant on offer card listings"
          />
        </CSSBreakpoint>
      </TextButton>
    } else {
      return <TextButton kind="secondary" nonInteractable>
        <CSSBreakpoint as="span" max="tablet">
          <FormattedMessage
            id="D0v8mAmdy1sWaJg3dsiV"
            defaultMessage="View"
            description="Short CTA label on mobile to view offer details in the offer listing section"
          />
        </CSSBreakpoint>
        <CSSBreakpoint as="span" min="desktop">
          <FormattedMessage
            id="fmQoCma2QV_Cs2oKJd4k"
            defaultMessage="View offer"
            description="CTA text-only button label for viewing the full offer details on offer card listings"
          />
        </CSSBreakpoint>
      </TextButton>
    }
  }
}
